/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1BrandsQueryResponse } from '../../types/GetV1Brands.ts'

export const getV1BrandsQueryKey = () => [{ url: '/v1/Brands' }] as const

export type GetV1BrandsQueryKey = ReturnType<typeof getV1BrandsQueryKey>

/**
 * {@link /v1/Brands}
 */
export async function getV1Brands(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<GetV1BrandsQueryResponse, ResponseErrorConfig<Error>, unknown>({
        method: 'GET',
        url: `/v1/Brands`,
        ...requestConfig,
    })
    return res
}

export function getV1BrandsQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1BrandsQueryKey()
    return queryOptions<
        ResponseConfig<GetV1BrandsQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1BrandsQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Brands(config)
        },
    })
}

/**
 * {@link /v1/Brands}
 */
export function useGetV1Brands<
    TData = ResponseConfig<GetV1BrandsQueryResponse>,
    TQueryData = ResponseConfig<GetV1BrandsQueryResponse>,
    TQueryKey extends QueryKey = GetV1BrandsQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1BrandsQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1BrandsQueryKey()

    const query = useQuery(
        {
            ...getV1BrandsQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
